import React, { createContext, useContext } from "react";
import type { SwipeListComponentProps } from "@components/SwipeList/types";
import SongDetails from "@components/BarMusicPlayer/SongDetails";

type BarSwipeListItemContextValue = {
  itemHeight: number;
  itemWidth: number;
  onPress: () => void;
};

const BarSwipeListItemContext = createContext<BarSwipeListItemContextValue | null>(
  null,
);

export function BarSwipeListItemProvider({
  itemHeight,
  itemWidth,
  onPress,
  children,
}: BarSwipeListItemContextValue & { children: React.ReactNode }) {
  return (
    <BarSwipeListItemContext.Provider value={{ itemHeight, itemWidth, onPress }}>
      {children}
    </BarSwipeListItemContext.Provider>
  );
}

export default function BarSwipeListItem({ item }: SwipeListComponentProps) {
  const ctx = useContext(BarSwipeListItemContext);
  if (!ctx) return null;

  return (
    <SongDetails
      item={item}
      itemHeight={ctx.itemHeight}
      itemWidth={ctx.itemWidth}
      onPress={ctx.onPress}
    />
  );
}

